module.exports = __webpack_public_path__ + "img/ico_business_3.a5e233a9.svg";